'use client'

import { HTMLProps } from 'react'
import clsx from 'classnames'
import { Link } from '@/routing'
import { BackButton } from './back-button'
import style from './breadcrumbs.module.scss'

type BreadcrumbsProps = HTMLProps<HTMLDivElement> & {
  showBackButton?: boolean
  items: {
    title: string
    path: string
  }[]
}

export const Breadcrumbs = ({ className, showBackButton = false, items }: BreadcrumbsProps) => {
  return (
    <ul className={clsx(style.container, 'main-padding', 'text text_type_d text_color_white-060', className)}>
      {showBackButton && <BackButton />}

      {items.map((el, i: number) => {
        return (
          <Link className={clsx(style.breadcrumb)} key={i} href={el.path}>
            {el.title}
          </Link>
        )
      })}
    </ul>
  )
}
